<template>
  <SelectSearchDropdown
    :options="timezones"
    :value="value"
    :placeholder="placeholder"
    @input="$emit('input', $event)"
  />
</template>

<script>
import timezones from '../constants/timezones';
import SelectSearchDropdown from './SelectSearchDropdown.vue';

export default {
  name: 'timezone-select',

  components: { SelectSearchDropdown },

  data() {
    return {
      timezones: timezones.map(timezone => ({ value: timezone, text: timezone })),
    };
  },

  props: { value: String, placeholder: String },
};
</script>
